"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uiKit = require("@devsta/ui-kit");

require("./styles/_profile-card.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ProfileCard(_ref) {
  var name = _ref.name,
      imageUrl = _ref.imageUrl,
      _ref$imageSize = _ref.imageSize,
      imageSize = _ref$imageSize === void 0 ? 30 : _ref$imageSize,
      className = _ref.className,
      onNameClickToGhost = _ref.onNameClickToGhost;
  return (/*#__PURE__*/_react.default.createElement(_uiKit.ToolTip, {
      id: "ghost-user",
      label: "Ghost This User",
      place: "bottom"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('profile-card', className),
      onClick: onNameClickToGhost,
      role: "button",
      tabIndex: 0,
      onKeyDown: onNameClickToGhost
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Image, {
      width: "".concat(imageSize, "px"),
      height: "".concat(imageSize, "px"),
      imageUrl: imageUrl,
      placeholderText: name,
      placeholderTextSize: 12,
      circular: true
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "profile-card__name"
    }, name)))
  );
}

var _default = (0, _react.memo)(ProfileCard);

exports.default = _default;